import React from 'react'
import styles from './UIGamePlayerInfoHeaderPointsPublic.module.scss'

interface UIGamePlayerInfoHeaderPointsPublicProps {
    points: number
    color: string
}

export const UIGamePlayerInfoHeaderPointsPublic = ({
    points,
    color,
}: UIGamePlayerInfoHeaderPointsPublicProps) => (
    <div className={styles.container} style={{'--color': color} as React.CSSProperties}>
        <div className={styles.points}>
            {points}
        </div>
    </div>
)
